<script setup>
import DocumentForm from '@frontJs/components/forms/projectManagement/DocumentForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { document, documentGroups } = defineProps({
    document: {
        type: [Object, null],
        required: false,
    },
    documentGroups: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="document">
            Mettre à jour le document #{{ document.id }} - Gestion de projet -
            Datakepler
        </title>

        <title v-else>Créer un document - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle v-if="document">
        Gestion de projet - Mettre à jour le document #{{ document.id }}
    </PageTitle>

    <PageTitle v-else> Gestion de projet - Créer un document </PageTitle>

    <DocumentForm :document="document" :document-groups="documentGroups" />
</template>
